"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPE_NONE = exports.TYPE_REMOVE = exports.TYPE_BUTTON = exports.TYPE_TEXT = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _richText = require("@eventmobi/rich-text");

var _Button = _interopRequireDefault(require("./Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)({
  root: {
    height: 'inherit',
    width: 'inherit',
    maxWidth: '720px',
    margin: 'auto',
    overflow: 'hidden'
  },
  title: {
    padding: '15px 15px 18px 15px',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center'
  },
  item: {
    textAlign: 'center',
    '& > p': {
      fontSize: '32px',
      lineHeight: '38px'
    },
    '& > span': {
      display: 'block',
      fontSize: '16px',
      paddingTop: '5px',
      lineHeight: '19px'
    }
  }
}, {
  name: 'Mui-WidgetCountdown'
});
var SECOND = 1;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
var TYPE_TEXT = 'text';
exports.TYPE_TEXT = TYPE_TEXT;
var TYPE_BUTTON = 'button';
exports.TYPE_BUTTON = TYPE_BUTTON;
var TYPE_REMOVE = 'remove';
exports.TYPE_REMOVE = TYPE_REMOVE;
var TYPE_NONE = 'none';
exports.TYPE_NONE = TYPE_NONE;

var calc = target => {
  var diff = Date.parse(new Date(target)) - Date.parse(new Date(Date.now()));

  if (diff <= 0) {
    return [{
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }, diff];
  }

  return [{
    days: Math.floor(diff / 1000 / DAY),
    hours: Math.floor(diff / 1000 / HOUR % 24),
    minutes: Math.floor(diff / 1000 / MINUTE % 60),
    seconds: Math.floor(diff / 1000 % 60)
  }, diff];
};

var useInterval = (callback, delay) => {
  var savedCallback = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    savedCallback.current = callback;
  });
  (0, _react.useEffect)(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return () => clearInterval(id);
    }

    return () => {};
  }, [delay]);
};

var useCountdown = function useCountdown(date) {
  var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  var [value, setValue] = (0, _react.useState)(null);
  var [delay, setDelay] = (0, _react.useState)(SECOND * 1000);
  useInterval(() => {
    var [next, diff] = calc(date);
    setValue(next);

    if (diff <= 0) {
      func();
      setDelay(null);
    }
  }, delay);
  (0, _react.useEffect)(() => {
    var [next, diff] = calc(date);
    setValue(next);

    if (diff > 0) {
      setDelay(SECOND * 1000);
    }
  }, [date]);
  return value;
};

var Countdown = (_ref) => {
  var {
    title,
    dayText = 'Days',
    dateTimeUTC,
    hourText = 'Hours',
    minText = 'Minutes',
    secText = 'Seconds',
    color: backgroundColor,
    postComplete: type,
    buttonProps,
    richText,
    onRichTextClick = () => {},
    font: fontFamily = 'Helvetica Neue',
    textColor
  } = _ref;

  if (type === TYPE_BUTTON && !buttonProps) {
    throw new Error('Button props are required when post complete behavior for countdown is set to button');
  }

  var classes = useStyles();
  var [postComplete, setPostComplete] = (0, _react.useState)(TYPE_NONE); // Reset the post complete state if date/time or the post complete type has been changed
  // and check if the countdown has already been completed, and render the post complete state directly

  (0, _react.useEffect)(() => {
    var [, diff] = calc(dateTimeUTC);

    if (diff <= 0) {
      setPostComplete(type || TYPE_NONE);
    } else {
      setPostComplete(TYPE_NONE);
    }
  }, [dateTimeUTC, type]);
  var countdown = useCountdown(dateTimeUTC, () => setPostComplete(type || TYPE_NONE)); // eslint-disable-next-line react/jsx-props-no-spreading

  var Text = values => /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    style: {
      fontFamily,
      color: textColor
    }
  }, values));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root,
    style: postComplete === TYPE_NONE ? {
      backgroundColor
    } : {}
  }, postComplete === TYPE_BUTTON && /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 1,
    width: 1
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, buttonProps))), postComplete === TYPE_TEXT && /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 1,
    width: 1
  }, richText && /*#__PURE__*/_react.default.createElement(_richText.Renderer, {
    onClick: onRichTextClick,
    content: richText
  })), postComplete === TYPE_NONE && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Text, {
    className: classes.title
  }, title), /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/_react.default.createElement(Text, {
    "data-testid": "days"
  }, (countdown === null || countdown === void 0 ? void 0 : countdown.days) >= 0 ? countdown === null || countdown === void 0 ? void 0 : countdown.days : '-'), /*#__PURE__*/_react.default.createElement(Text, {
    variant: "caption"
  }, dayText)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/_react.default.createElement(Text, {
    "data-testid": "hours"
  }, (countdown === null || countdown === void 0 ? void 0 : countdown.hours) >= 0 ? countdown === null || countdown === void 0 ? void 0 : countdown.hours : '-'), /*#__PURE__*/_react.default.createElement(Text, {
    variant: "caption"
  }, hourText)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/_react.default.createElement(Text, {
    "data-testid": "minutes"
  }, (countdown === null || countdown === void 0 ? void 0 : countdown.minutes) >= 0 ? countdown === null || countdown === void 0 ? void 0 : countdown.minutes : '-'), /*#__PURE__*/_react.default.createElement(Text, {
    variant: "caption"
  }, minText)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 3,
    className: classes.item
  }, /*#__PURE__*/_react.default.createElement(Text, {
    "data-testid": "seconds"
  }, (countdown === null || countdown === void 0 ? void 0 : countdown.seconds) >= 0 ? countdown === null || countdown === void 0 ? void 0 : countdown.seconds : '-'), /*#__PURE__*/_react.default.createElement(Text, {
    variant: "caption"
  }, secText)))));
};

Countdown.propTypes = {
  /**
   * Title will be displayed on the top of the widget
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Text will be added below day
   */
  dayText: _propTypes.default.string,

  /**
   * Text will be added below hour
   */
  hourText: _propTypes.default.string,

  /**
   * Text will be added below minute
   */
  minText: _propTypes.default.string,

  /**
   * Text will be added below second
   */
  secText: _propTypes.default.string,

  /**
   * background color for the widget
   */
  color: _propTypes.default.string,

  /**
   * Type of post complete behavior
   */
  postComplete: _propTypes.default.oneOf([TYPE_TEXT, TYPE_REMOVE, TYPE_BUTTON, TYPE_NONE]),

  /**
   * This is the html content
   */
  richText: _propTypes.default.string,

  /**
   * Callback to handle anchor clicks inside HTML content
   */
  onRichTextClick: _propTypes.default.func,

  /**
   * Font family for button label
   */
  font: _propTypes.default.string,

  /**
   * Font size for button text
   */
  textColor: _propTypes.default.string,

  /**
   * Props for customized button widget to render post complete
   */
  buttonProps: _propTypes.default.shape({// Props for button widget
  }),

  /**
   * Event Date time in UTC to calculate the countdown
   */
  dateTimeUTC: _propTypes.default.string
};
var _default = Countdown;
exports.default = _default;